<template>
<div class="chapter">
<div class="inner_page">
<a id="page_6"></a>
<h1 class="toc-title">Contents</h1>
<p class="toc"><a href="#/xhtml/07_Introduction"><span class="bold">Introduction</span></a></p>
<p class="toc1z"><a href="#/xhtml/08_Chapter01"><span class="bold">Stitching know-how</span></a></p>
<p class="toc"><a href="#/xhtml/08_Chapter01#sub1">Stitching projects</a></p>
<p class="toc1z"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="bold">Papercraft know-how</span></span></p>
<p class="toc"><span href="#/xhtml/09_Chapter02#sub2" title="Link target outside of Sample">Papercraft projects</span></p>
<p class="toc1z"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample"><span class="bold">Knitting know-how</span></span></p>
<p class="toc"><span href="#/xhtml/10_Chapter03#sub3" title="Link target outside of Sample">Knitting projects</span></p>
<p class="toc1z"><span href="#/xhtml/11_Chapter04" title="Link target outside of Sample"><span class="bold">Jewellery know-how</span></span></p>
<p class="toc"><span href="#/xhtml/11_Chapter04#sub4" title="Link target outside of Sample">Jewellery projects</span></p>
<p class="toc1z"><span href="#/xhtml/12_Chapter05" title="Link target outside of Sample"><span class="bold">Crochet know-how</span></span></p>
<p class="toc"><span href="#/xhtml/12_Chapter05#sub5" title="Link target outside of Sample">Crochet projects</span></p>
<p class="toc1z"><span href="#/xhtml/13_Chapter06" title="Link target outside of Sample"><span class="bold">Sugarcraft know-how</span></span></p>
<p class="toc"><span href="#/xhtml/13_Chapter06#sub6" title="Link target outside of Sample">Sugarcraft projects</span></p>
<p class="toc1z"><span href="#/xhtml/14_Chapter07" title="Link target outside of Sample"><span class="bold">Polymer clay know-how</span></span></p>
<p class="toc"><span href="#/xhtml/14_Chapter07#sub7" title="Link target outside of Sample">Polymer clay projects</span></p>
<div class="figure">
<img alt="" src="images/pg5-1.jpg"/>
<p class="caption"><em class="italic">Flowery Bunting, <a href="#/xhtml/08_Chapter01#page_20">page 20</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg5-2.jpg"/>
<p class="caption"><em class="italic">Pompom Cupcakes, <a href="#/xhtml/08_Chapter01#page_22">page 22</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg5-3.jpg"/>
<p class="caption"><em class="italic">Felt Winter Owl, <a href="#/xhtml/08_Chapter01#page_24">page 24</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg5-4.jpg"/>
<p class="caption"><em class="italic">Scottie Dog Brooch <a href="#/xhtml/08_Chapter01#page_26">page 26</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg5-5.jpg"/>
<p class="caption"><em class="italic">Cross Stitch Heart, <a href="#/xhtml/08_Chapter01#page_28">page 28</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg5-6.jpg"/>
<p class="caption"><em class="italic">Jelly Roll Bag, <a href="#/xhtml/08_Chapter01#page_30">page 30</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg5-7.jpg"/>
<p class="caption"><em class="italic">Pompom Santa, <a href="#/xhtml/08_Chapter01#page_32">page 32</a></em></p>
</div>
<div class="figure"><a id="page_7">
<img alt="" src="images/pg6-1.jpg"/>
</a><p class="caption"><a id="page_7"><em class="italic">Daisy Brooch, </em></a><a href="#/xhtml/08_Chapter01#page_34">page 34</a></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-2.jpg"/>
<p class="caption"><em class="italic">Christmas Bunting, <a href="#/xhtml/08_Chapter01#page_36">page 36</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-3.jpg"/>
<p class="caption"><em class="italic">Feltie Mouse, <a href="#/xhtml/08_Chapter01#page_38">page 38</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-4.jpg"/>
<p class="caption"><em class="italic">Felt Duck Brooch, <a href="#/xhtml/08_Chapter01#page_40">page 40</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-5.jpg"/>
<p class="caption"><em class="italic">Fur Scatter Pillow, <a href="#/xhtml/08_Chapter01#page_42">page 42</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-6.jpg"/>
<p class="caption"><em class="italic">Needlepoint Hen, <a href="#/xhtml/08_Chapter01#page_44">page 44</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-7.jpg"/>
<p class="caption"><em class="italic">Silk Ribbon Poinsettia, <a href="#/xhtml/08_Chapter01#page_46">page 46</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-8.jpg"/>
<p class="caption"><em class="italic">Christmas Tea Light, <a href="#/xhtml/08_Chapter01#page_48">page 48</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-9.jpg"/>
<p class="caption"><em class="italic">Felt Place Setting, <a href="#/xhtml/08_Chapter01#page_50">page 50</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-10.jpg"/>
<p class="caption"><em class="italic">Heart Brooch, <a href="#/xhtml/08_Chapter01#page_52">page 52</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-11.jpg"/>
<p class="caption"><em class="italic">Jelly Roll Pillow, <a href="#/xhtml/08_Chapter01#page_54">page 54</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-12.jpg"/>
<p class="caption"><em class="italic">Pompom Card Pegs, <a href="#/xhtml/08_Chapter01#page_56">page 56</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-13.jpg"/>
<p class="caption"><em class="italic">Fabric Button Flower, <a href="#/xhtml/08_Chapter01#page_58">page 58</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-14.jpg"/>
<p class="caption"><em class="italic">Needlepoint Snowman, <a href="#/xhtml/08_Chapter01#page_60">page 60</a></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6-15.jpg"/>
<p class="caption"><em class="italic">Christmas Tree Papercut, <span href="#/xhtml/09_Chapter02#page_64" title="Link target outside of Sample">page 64</span></em></p>
</div>
<div class="figure"><a id="page_8">
<img alt="" src="images/pg6a-1.jpg"/>
</a><p class="caption"><a id="page_8"><em class="italic">Tree Santa Gift Box, </em></a><span href="#/xhtml/09_Chapter02#page_66" title="Link target outside of Sample">page 66</span></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-2.jpg"/>
<p class="caption"><em class="italic">Quilled Reindeer, <span href="#/xhtml/09_Chapter02#page_68" title="Link target outside of Sample">page 68</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-3.jpg"/>
<p class="caption"><em class="italic">Decoupage Candles, <span href="#/xhtml/09_Chapter02#page_70" title="Link target outside of Sample">page 70</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-4.jpg"/>
<p class="caption"><em class="italic">Washi Tape Card, <span href="#/xhtml/09_Chapter02#page_72" title="Link target outside of Sample">page 72</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-5.jpg"/>
<p class="caption"><em class="italic">Decoupage Desk Tidy, <span href="#/xhtml/09_Chapter02#page_74" title="Link target outside of Sample">page 74</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-6.jpg"/>
<p class="caption"><em class="italic">Rainy Day Papercut, <span href="#/xhtml/09_Chapter02#page_76" title="Link target outside of Sample">page 76</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-7.jpg"/>
<p class="caption"><em class="italic">Quilled Flying Pigs, <span href="#/xhtml/09_Chapter02#page_78" title="Link target outside of Sample">page 78</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-8.jpg"/>
<p class="caption"><em class="italic">Decoupage Crackle Mirror, <span href="#/xhtml/09_Chapter02#page_80" title="Link target outside of Sample">page 80</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-9.jpg"/>
<p class="caption"><em class="italic">Snowflake Headband, <span href="#/xhtml/10_Chapter03#page_86" title="Link target outside of Sample">page 86</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-10.jpg"/>
<p class="caption"><em class="italic">Twinkling Star, <span href="#/xhtml/10_Chapter03#page_88" title="Link target outside of Sample">page 88</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-11.jpg"/>
<p class="caption"><em class="italic">Snowflakes Mug Hug, <span href="#/xhtml/10_Chapter03#page_90" title="Link target outside of Sample">page 90</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-12.jpg"/>
<p class="caption"><em class="italic">Frosty Wrist Warmers, <span href="#/xhtml/10_Chapter03#page_92" title="Link target outside of Sample">page 92</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6a-13.jpg"/>
<p class="caption"><em class="italic">Holly Christmas Bear, <span href="#/xhtml/10_Chapter03#page_94" title="Link target outside of Sample">page 94</span></em></p>
</div>
<div class="figure"><a id="page_9">
<img alt="" src="images/pg6b-1.jpg"/>
</a><p class="caption"><a id="page_9"><em class="italic">Bobble Scarf, </em></a><span href="#/xhtml/10_Chapter03#page_98" title="Link target outside of Sample">page 98</span></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-2.jpg"/>
<p class="caption"><em class="italic">Knitted Pear, <span href="#/xhtml/10_Chapter03#page_100" title="Link target outside of Sample">page 100</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-3.jpg"/>
<p class="caption"><em class="italic">Penguin Boot Cuffs, <span href="#/xhtml/10_Chapter03#page_102" title="Link target outside of Sample">page 102</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-4.jpg"/>
<p class="caption"><em class="italic">Christmas Holly Cake, <span href="#/xhtml/10_Chapter03#page_104" title="Link target outside of Sample">page 104</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-5.jpg"/>
<p class="caption"><em class="italic">Crystal Phone Sock, <span href="#/xhtml/10_Chapter03#page_106" title="Link target outside of Sample">page 106</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-6.jpg"/>
<p class="caption"><em class="italic">Pumpkin, <span href="#/xhtml/10_Chapter03#page_108" title="Link target outside of Sample">page 108</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-7.jpg"/>
<p class="caption"><em class="italic">Stripes Tea Cosy, <span href="#/xhtml/10_Chapter03#page_110" title="Link target outside of Sample">page 110</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-8.jpg"/>
<p class="caption"><em class="italic">Periwinkle, <span href="#/xhtml/10_Chapter03#page_112" title="Link target outside of Sample">page 112</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-9.jpg"/>
<p class="caption"><em class="italic">Bow Beanie, <span href="#/xhtml/10_Chapter03#page_114" title="Link target outside of Sample">page 114</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-10.jpg"/>
<p class="caption"><em class="italic">Berry Bootees, <span href="#/xhtml/10_Chapter03#page_116" title="Link target outside of Sample">page 116</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-11.jpg"/>
<p class="caption"><em class="italic">Wave Headband, <span href="#/xhtml/10_Chapter03#page_118" title="Link target outside of Sample">page 118</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-12.jpg"/>
<p class="caption"><em class="italic">Christmas Tree, <span href="#/xhtml/10_Chapter03#page_120" title="Link target outside of Sample">page 120</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg6b-13.jpg"/>
<p class="caption"><em class="italic">Heart Mug Hug, <span href="#/xhtml/10_Chapter03#page_122" title="Link target outside of Sample">page 122</span></em></p>
</div>
<div class="figure"><a id="page_10">
<img alt="" src="images/pg7a-1.jpg"/>
</a><p class="caption"><a id="page_10"><em class="italic">Fair Isle Wrist Warmers, </em></a><span href="#/xhtml/10_Chapter03#page_124" title="Link target outside of Sample">page 124</span></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-2.jpg"/>
<p class="caption"><em class="italic">Red Rooster Scarf, <span href="#/xhtml/10_Chapter03#page_126" title="Link target outside of Sample">page 126</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-3.jpg"/>
<p class="caption"><em class="italic">Rocking Robin, <span href="#/xhtml/10_Chapter03#page_128" title="Link target outside of Sample">page 128</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-4.jpg"/>
<p class="caption"><em class="italic">Rose Corsage, <span href="#/xhtml/10_Chapter03#page_130" title="Link target outside of Sample">page 130</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-5.jpg"/>
<p class="caption"><em class="italic">Sea Bride Bracelet, <span href="#/xhtml/11_Chapter04#page_134" title="Link target outside of Sample">page 134</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-6.jpg"/>
<p class="caption"><em class="italic">Precious Stone Necklace, <span href="#/xhtml/11_Chapter04#page_136" title="Link target outside of Sample">page 136</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-7.jpg"/>
<p class="caption"><em class="italic">Daisy Button Bangle, <span href="#/xhtml/11_Chapter04#page_138" title="Link target outside of Sample">page 138</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-8.jpg"/>
<p class="caption"><em class="italic">Butterfly Friendship Bracelet, <span href="#/xhtml/11_Chapter04#page_140" title="Link target outside of Sample">page 140</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-9.jpg"/>
<p class="caption"><em class="italic">Steampunk Butterfly Ring, <span href="#/xhtml/11_Chapter04#page_142" title="Link target outside of Sample">page 142</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-10.jpg"/>
<p class="caption"><em class="italic">Grecian Pearls Tiara, <span href="#/xhtml/11_Chapter04#page_144" title="Link target outside of Sample">page 144</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-11.jpg"/>
<p class="caption"><em class="italic">Pewter Heart Necklace, <span href="#/xhtml/11_Chapter04#page_146" title="Link target outside of Sample">page 146</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-12.jpg"/>
<p class="caption"><em class="italic">Bubble Gum Charm, <span href="#/xhtml/11_Chapter04#page_148" title="Link target outside of Sample">page 148</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7a-13.jpg"/>
<p class="caption"><em class="italic">Celtic Bracelet, <span href="#/xhtml/11_Chapter04#page_150" title="Link target outside of Sample">page 150</span></em></p>
</div>
<div class="figure"><a id="page_11">
<img alt="" src="images/pg7b-1.jpg"/>
</a><p class="caption"><a id="page_11"><em class="italic">Calla Lily Earrings, </em></a><span href="#/xhtml/11_Chapter04#page_152" title="Link target outside of Sample">page 152</span></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-2.jpg"/>
<p class="caption"><em class="italic">Statement Ring, <span href="#/xhtml/11_Chapter04#page_154" title="Link target outside of Sample">page 154</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-3.jpg"/>
<p class="caption"><em class="italic">Beaded Felt Hairslide, 156</em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-4.jpg"/>
<p class="caption"><em class="italic">Glittery Beanie, <span href="#/xhtml/12_Chapter05#page_160" title="Link target outside of Sample">page 160</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-5.jpg"/>
<p class="caption"><em class="italic">Christmas Stocking, <span href="#/xhtml/12_Chapter05#page_162" title="Link target outside of Sample">page 162</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-6.jpg"/>
<p class="caption"><em class="italic">Teddy Bear, <span href="#/xhtml/12_Chapter05#page_164" title="Link target outside of Sample">page 164</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-7.jpg"/>
<p class="caption"><em class="italic">Orange Blossom, <span href="#/xhtml/12_Chapter05#page_168" title="Link target outside of Sample">page 168</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-8.jpg"/>
<p class="caption"><em class="italic">Christmas Star, <span href="#/xhtml/12_Chapter05#page_170" title="Link target outside of Sample">page 170</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-9.jpg"/>
<p class="caption"><em class="italic">Tate Purse, <span href="#/xhtml/12_Chapter05#page_172" title="Link target outside of Sample">page 172</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-10.jpg"/>
<p class="caption"><em class="italic">Christmas Tree Heart, <span href="#/xhtml/12_Chapter05#page_174" title="Link target outside of Sample">page 174</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-11.jpg"/>
<p class="caption"><em class="italic">Hellebore Granny Square Flower, <span href="#/xhtml/12_Chapter05#page_176" title="Link target outside of Sample">page 176</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-12.jpg"/>
<p class="caption"><em class="italic">Winter Beanie, <span href="#/xhtml/12_Chapter05#page_178" title="Link target outside of Sample">page 178</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg7b-13.jpg"/>
<p class="caption"><em class="italic">Filet Baby Blanket, <span href="#/xhtml/12_Chapter05#page_180" title="Link target outside of Sample">page 180</span></em></p>
</div>
<div class="figure"><a id="page_12">
<img alt="" src="images/pg8a-1.jpg"/>
</a><p class="caption"><a id="page_12"><em class="italic">Bernie the Christmas Elf, </em></a><span href="#/xhtml/12_Chapter05#page_182" title="Link target outside of Sample">page 182</span></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-2.jpg"/>
<p class="caption"><em class="italic">African Violets, <span href="#/xhtml/12_Chapter05#page_184" title="Link target outside of Sample">page 184</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-3.jpg"/>
<p class="caption"><em class="italic">Festive Wreath, <span href="#/xhtml/12_Chapter05#page_186" title="Link target outside of Sample">page 186</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-4.jpg"/>
<p class="caption"><em class="italic">Lottie Purse, <span href="#/xhtml/12_Chapter05#page_188" title="Link target outside of Sample">page 188</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-5.jpg"/>
<p class="caption"><em class="italic">Heart String, <span href="#/xhtml/12_Chapter05#page_190" title="Link target outside of Sample">page 190</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-6.jpg"/>
<p class="caption"><em class="italic">Anemone Granny Square Flower, <span href="#/xhtml/12_Chapter05#page_192" title="Link target outside of Sample">page 192</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-7.jpg"/>
<p class="caption"><em class="italic">Christmas Rose, <span href="#/xhtml/13_Chapter06#page_198" title="Link target outside of Sample">page 198</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-8.jpg"/>
<p class="caption"><em class="italic">Pretty Poodle, <span href="#/xhtml/13_Chapter06#page_200" title="Link target outside of Sample">page 200</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-9.jpg"/>
<p class="caption"><em class="italic">Lion, <span href="#/xhtml/13_Chapter06#page_202" title="Link target outside of Sample">page 202</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-10.jpg"/>
<p class="caption"><em class="italic">Choirboy, <span href="#/xhtml/13_Chapter06#page_204" title="Link target outside of Sample">page 204</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-11.jpg"/>
<p class="caption"><em class="italic">Winter Fairy, <span href="#/xhtml/13_Chapter06#page_206" title="Link target outside of Sample">page 206</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-12.jpg"/>
<p class="caption"><em class="italic">Lovebirds, <span href="#/xhtml/13_Chapter06#page_208" title="Link target outside of Sample">page 208</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8a-13.jpg"/>
<p class="caption"><em class="italic">Santa Claus, <span href="#/xhtml/13_Chapter06#page_210" title="Link target outside of Sample">page 210</span></em></p>
</div>
<div class="figure"><a id="page_13">
<img alt="" src="images/pg8b-1.jpg"/>
</a><p class="caption"><a id="page_13"><em class="italic">Elf Boots, </em></a><span href="#/xhtml/13_Chapter06#page_212" title="Link target outside of Sample">page 212</span></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-2.jpg"/>
<p class="caption"><em class="italic">Owl, <span href="#/xhtml/13_Chapter06#page_214" title="Link target outside of Sample">page 214</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-3.jpg"/>
<p class="caption"><em class="italic">Red Glitter Bag, <span href="#/xhtml/13_Chapter06#page_216" title="Link target outside of Sample">page 216</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-4.jpg"/>
<p class="caption"><em class="italic">Cordelia Cat, <span href="#/xhtml/13_Chapter06#page_218" title="Link target outside of Sample">page 218</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-5.jpg"/>
<p class="caption"><em class="italic">Christmas Charms, <span href="#/xhtml/14_Chapter07#page_222" title="Link target outside of Sample">page 222</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-6.jpg"/>
<p class="caption"><em class="italic">Teddy Bear, <span href="#/xhtml/14_Chapter07#page_224" title="Link target outside of Sample">page 224</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-7.jpg"/>
<p class="caption"><em class="italic">Owl Button, <span href="#/xhtml/14_Chapter07#page_226" title="Link target outside of Sample">page 226</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-8.jpg"/>
<p class="caption"><em class="italic">Gingerbread Charms, <span href="#/xhtml/14_Chapter07#page_228" title="Link target outside of Sample">page 228</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-9.jpg"/>
<p class="caption"><em class="italic">Christmas Bear, <span href="#/xhtml/14_Chapter07#page_230" title="Link target outside of Sample">page 230</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-10.jpg"/>
<p class="caption"><em class="italic">Pizza Necklace, <span href="#/xhtml/14_Chapter07#page_232" title="Link target outside of Sample">page 232</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-11.jpg"/>
<p class="caption"><em class="italic">Melon Slice Earrings, <span href="#/xhtml/14_Chapter07#page_234" title="Link target outside of Sample">page 234</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-12.jpg"/>
<p class="caption"><em class="italic">Polar Bear, <span href="#/xhtml/14_Chapter07#page_236" title="Link target outside of Sample">page 236</span></em></p>
</div>
<div class="figure">
<img alt="" src="images/pg8b-13.jpg"/>
<p class="caption"><em class="italic">Cupcake Button, <span href="#/xhtml/14_Chapter07#page_238" title="Link target outside of Sample">page 238</span></em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?172214de